export class ReservationRequest {
}
//# sourceMappingURL=reservation-request.js.map